/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Fragment } from 'react'
import { Modal } from 'antd-mobile'
import _ from 'lodash'
// css
import { observer } from 'mobx-react'
import { AdvDialogStyle } from '@styles/modal'
import { Button, EventFooter } from '@styles/button.style'
import { isMobile } from 'react-device-detect'
import useRootStore from '@store/useRootStore'
import { ModalBg } from '@styles/base.style'
import StorageUtils from '@utils/storage-utils'
import PopupUtils from '@utils/popup-utils'

const MatchUpBottomBanner: React.FC = observer((): React.ReactElement => {
  const { globalStore, componentStore } = useRootStore()
  const { visibleMatchupBottomBannerPopup } = globalStore
  const { matchupBottomBanner } = componentStore

  if (_.isEmpty(matchupBottomBanner)) {
    globalStore.setVisibleMatchupBottomBannerPopup(false)
    return
  }

  const onClose = (): void => {
    globalStore.setVisibleMatchupBottomBannerPopup(false)
  }

  const onCloseHideModal = (): void => {
    StorageUtils.saveMatchupBottomBannerHide()
    onClose()
  }

  const onCloseBannerWeek = (): void => {
    StorageUtils.saveMatchupBottomBannerShowNext7Days()
    onClose()
  }

  const onClickAdvNoticePopup = (): void => {
    if (matchupBottomBanner.contentsImageUrl) {
      componentStore.setSelectedGameBanner(matchupBottomBanner)
      PopupUtils.showMatchupBannerPopup()
      onCloseHideModal()
    }
  }

  const bannerImageElem: JSX.Element = (
    <Button TP className={isMobile ? 'match-up-modal-btn' : 'match-up-modal-btn pc'} onClick={(): void => {
      onClickAdvNoticePopup()
    }}>
      <img
        src={matchupBottomBanner.matchupBottomImageUrl}
        alt={matchupBottomBanner.desc} className="club-event-list--item--img"
        style={{ width: '100%' }}
      />
    </Button>
  )

  return (
    <Fragment>
      <Modal
        popup
        maskClosable={false}
        visible={visibleMatchupBottomBannerPopup}
        animated={isMobile}
        animationType="slide-up"
        className="new-slide-type match-up-modal"
        css={AdvDialogStyle}
      >
        {bannerImageElem}

        <div css={EventFooter} className="match-up-modal">
          <input type="checkbox" id="check" onClick={onCloseBannerWeek}/>
          <label htmlFor="check" className="check-label">
            <span className="check-label-ico">체크</span>
            <span className="check-label-txt">7일 동안 보지 않기</span>
          </label>

          <Button className="event-popup-btn-cls" onClick={onCloseHideModal}>
            <span className="cls-txt">닫기</span>
          </Button>
        </div>
        <ModalBg className="modal-bg"/>
      </Modal>
    </Fragment>
  )
})

export default MatchUpBottomBanner
